import { AppointmentStep } from "@/features/modals/bookAppointmentModal/AppointmentStep";
import { t } from "@repo/translation";
import { ModalSheet } from "@repo/ui";

interface BookAppointmentModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

export const BookAppointmentModal = ({
  isOpen,
  closeModal,
}: BookAppointmentModalProps) => {
  const onClose = () => {
    closeModal();
  };

  return (
    <ModalSheet
      title={t("action.book_appointment")}
      visible={isOpen}
      onClose={onClose}
    >
      <AppointmentStep />
    </ModalSheet>
  );
};
